import { HttpInterceptors } from "./http.interceptor";

export class ProductService extends HttpInterceptors {
	async listProduct (filters) {
		const response = await this.axios.get("product/listProduct", { params: { filters } });
		return response.data;
	}

	async upsertProduct (payload) {
		const response = await this.axios.post("product/upsertProduct", payload);
		return response.data;
	}

	async deleteProduct (id) {
		const response = await this.axios.delete("product/deleteProduct", { params: id });
		return response.data;
	}

	async reportProduct (filters) {
		const response = await this.axios.get("product/reportProduct", { params: { filters } });
		return response.data;
	}

	async reportProductSale (filters) {
		const response = await this.axios.get("product/reportProductSale", { params: { filters } });
		return response.data;
	}
}
